import React from 'react';
import { Container } from 'react-bootstrap';
import Header from '../../Components/Header';
import Footer from '../../Components/Footer';
import Blogimg from '../../Components/Blog/Blogimg';
import BlogReadmore from '../../Components/Blog/BlogReadmore';

function Blogs() {
    
  return (
    <div>
      <Container fluid style={{ margin: 0, padding: 0 }} >
        <div>
          <Header title="blog" />
        </div>

        <div>
          <Blogimg/>
        </div>

        <div>
          <BlogReadmore/>
        </div>
        

     <div>
      <Footer/>
     </div>

      </Container>
    </div>
    
  );
}

export default Blogs